import React from "react";

const SuccessIcon = ({props}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
  <path d="M71.1998 43.7152C68.7039 56.2075 59.2946 67.9702 46.0915 70.5986C39.6521 71.8823 32.9723 71.0996 27.0032 68.3619C21.034 65.6242 16.0799 61.0711 12.8461 55.3509C9.61236 49.6307 8.26385 43.0351 8.9926 36.503C9.72135 29.971 12.4902 23.8356 16.9049 18.9705C25.9599 8.98669 41.2495 6.23839 53.7288 11.2353" stroke="#29CE00" stroke-width="5.82732" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M28.75 38.75L41.25 51.25L71.25 18.75" stroke="#29CE00" stroke-width="5.82732" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);
export default SuccessIcon;
